<template>
    <a class="kb-revert" :title="title || $t('knowledgebase.revert')" @click.prevent="$emit('click')">
        <i class="fa fa-undo" />
    </a>
</template>

<script>
export default {
    name: 'kb-revert',
    props: {
        title: {type: String, default: ''},
    },
};
</script>

<style lang="scss" scoped>
@import '../../../variables';

.kb-revert {
    display: inline-flex;
    align-items: center;
    color: #aaa;
    font-size: 0.7em;
    cursor: pointer;
    padding: 0 4px;

    &:hover {
        color: $mc-primary;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/pages/knowledge-base/kb-revert.vue